/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Add_Success2Inputs */

const en_coinvestments_dataroom_add_success2 = /** @type {(inputs: Coinvestments_Dataroom_Add_Success2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data room added successfully`)
};

/**
* | output |
* | --- |
* | "Data room added successfully" |
*
* @param {Coinvestments_Dataroom_Add_Success2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_add_success2 = /** @type {((inputs?: Coinvestments_Dataroom_Add_Success2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Add_Success2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_add_success2(inputs)
});
export { coinvestments_dataroom_add_success2 as "coInvestments_dataRoom_add_success" }